function requireEnv(name: string, value: string | undefined): string {
  if (!value?.trim()) throw new Error(`[appConfig] Missing required environment variable: ${name}`)
  return value
}

function requireBaseUrl(name: string, value: string | undefined): string {
  return requireEnv(name, value).replace(/\/+$/, '')
}

/** 国内版 H5 的唯一运行时配置入口。 */
export const appConfig = Object.freeze({
  apiBaseUrl: requireBaseUrl('VITE_API_DOMAIN', import.meta.env.VITE_API_DOMAIN),
  ossQrCodeUrl: requireEnv('VITE_OSS_QRCODE_URL', import.meta.env.VITE_OSS_QRCODE_URL),
  regionType: 'cn' as const,
  regionSync: Object.freeze({
    accessKeyId: requireEnv('VITE_REGION_ACCESS_KEY_ID', import.meta.env.VITE_REGION_ACCESS_KEY_ID),
    accessKeySecret: requireEnv('VITE_REGION_ACCESS_KEY_SECRET', import.meta.env.VITE_REGION_ACCESS_KEY_SECRET),
  }),
})
